import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';

const AuthWrapper = styled('div')({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '40px 20px',
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: '#08090d',
});

const GlassCard = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '480px',
  background: 'rgba(20, 24, 36, 0.7)',
  backdropFilter: 'blur(12px)',
  WebkitBackdropFilter: 'blur(12px)',
  border: '1px solid rgba(255, 255, 255, 0.08)',
  borderRadius: '24px',
  padding: '40px',
  position: 'relative',
  zIndex: 1,
  boxShadow: '0 20px 50px rgba(0, 0, 0, 0.5)',
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: '24px',
    padding: '1px',
    background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1), transparent, rgba(61, 127, 255, 0.1))',
    WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    WebkitMaskComposite: 'xor',
    maskComposite: 'exclude',
    pointerEvents: 'none',
  }
}));

const LogoLink = styled(Link)({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  textDecoration: 'none',
  marginBottom: '32px',
  justifyContent: 'center',
});

const AuthLayout = ({ children, title, subtitle }) => {
  return (
    <AuthWrapper className="artemy-root">
      <div className="artemy-grid-bg" />
      
      {/* Decorative Blur Orbs */}
      <Box sx={{
        position: 'absolute',
        top: '10%',
        left: '10%',
        width: '400px',
        height: '400px',
        background: 'rgba(61, 127, 255, 0.05)',
        filter: 'blur(100px)',
        borderRadius: '50%',
        zIndex: 0,
      }} />
      <Box sx={{
        position: 'absolute',
        bottom: '10%',
        right: '10%',
        width: '300px',
        height: '300px',
        background: 'rgba(0, 212, 170, 0.05)',
        filter: 'blur(80px)',
        borderRadius: '50%',
        zIndex: 0,
      }} />

      <GlassCard className="artemy-fade-up">
        <LogoLink to="/">
          <svg width="32" height="32" viewBox="0 0 28 28" fill="none">
            <rect x="3" y="3" width="10" height="10" rx="2.5" fill="#3d7fff" opacity=".9" />
            <rect x="15" y="3" width="10" height="10" rx="2.5" fill="#3d7fff" opacity=".4" />
            <rect x="3" y="15" width="10" height="10" rx="2.5" fill="#3d7fff" opacity=".4" />
            <rect x="15" y="15" width="10" height="10" rx="2.5" fill="#00d4aa" opacity=".85" />
            <circle cx="14" cy="14" r="3" fill="#fff" opacity=".9" />
          </svg>
          <span style={{ 
            fontFamily: 'var(--artemy-font-display)', 
            fontWeight: 800, 
            fontSize: '22px', 
            color: '#fff', 
            letterSpacing: '-.5px' 
          }}>
            artemy<span style={{ color: 'var(--artemy-accent)' }}>.ai</span>
          </span>
        </LogoLink>

        {title && (
          <Typography 
            variant="h4" 
            sx={{ 
              fontFamily: 'var(--artemy-font-display)', 
              fontWeight: 700, 
              color: '#fff',
              textAlign: 'center',
              mb: 1,
              fontSize: '28px'
            }}
          >
            {title}
          </Typography>
        )}
        
        {subtitle && (
          <Typography 
            variant="body2" 
            sx={{ 
              color: 'var(--artemy-text-secondary)',
              textAlign: 'center',
              mb: 4,
              fontSize: '14px'
            }}
          >
            {subtitle}
          </Typography>
        )}

        {children}
      </GlassCard>
    </AuthWrapper>
  );
};

export default AuthLayout;
